Vue.component('barchart', {
    props: {
        featured: {
            type: Array
        },
        allData: {},
        field: {
            type: Object,
            required: false
        }   
    },
    data () {
        return {
            chartid: 'chart_' + this.makeid(),
            svg: false,
            width: '500',
            height: '500',
            tooltip: false
        }
    },
    computed: {
        tooltipid () {
            return "tooltip_" + this.chartid;
        },
        sortedData () {
            let self = this;
            order = Object.keys(self.allData).sort( function (keyA, keyB) {
                if(self.allData[keyB].value > self.allData[keyA].value) {return 1; }
                else {return -1;}                        
            });
            let newObj = [];
            order.forEach(item => {
                newObj.push(self.allData[item*1]);
            });             
            return newObj;
        }
    },
    mounted () {
        let $this = this;
        let data = $this.sortedData;
        let width = $this.width;
        let height = $this.height;
        let margin = ({top: 30, right: 10, bottom: 10, left: 10})
        
        let x = d3.scaleLinear()
            .domain([0, d3.max(data, d => d.value)])
            .range([margin.left, width - margin.right]);

        let y = d3.scaleBand()
            .domain(d3.range(data.length))
            .rangeRound([margin.top, height - margin.bottom])
            .padding(0.1)
        
        /*
        let xAxis = g => g
            .attr("transform", `translate(0,${margin.top})`)
            .call(d3.axisTop(x).ticks(width / 80, data.format))
            .call(g => g.select(".domain").remove())

        let yAxis = g => g
            .attr("transform", `translate(${margin.left},0)`)
            .call(d3.axisLeft(y).tickFormat(i => data[i].district).tickSizeOuter(0))
        */
        let barHeight = 25;

        format = x.tickFormat(20, data.format)

        $this.svg = d3.select("#" + $this.chartid + " svg")
        $this.svg.attr("viewBox", [0, 0, this.width, this.height]);
        $this.svg.append("g")
                
            .selectAll("rect")
            .data(data)
            .join("rect")
                .attr("x", x(0))
                .attr("y", (d, i) => y(i))
                .attr("width", d => x(d.value) - x(0))
                .attr("height", y.bandwidth())
                .attr("class", function (d) {if (d.featured) {return 'featured';} return '';})
                .on("mouseover", function(event, d) {
                    $this.mouseover(event, d);                    
                    d3.select(this)
                        .attr("class", function (d) {return 'highlight'});
                })
                
                .on("mouseout", function(d, i) {
                    $this.tooltip.transition()
                        .duration(200)
                        .style("opacity", 0);
                    d3.select(this)
                        .attr("class", function (d) {if (d.featured) {return 'featured';} return '';})

                })
                .on("click", (event, d) => {return;});
                

        $this.svg.append("g")
            .attr("fill", "white")
            .attr("text-anchor", "end")
            .attr("font-family", "sans-serif")
            .attr("font-size", 12)
            .selectAll("text")
            .data(data)
            .join("text")
            .attr("x", d => x(d.value))
            .attr("y", (d, i) => y(i) + y.bandwidth() / 2)
            .attr("dy", "0.35em")
            .attr("dx", -4)
            //.text(d => format(d.value))
            // .text(d => formatSlideData(d.value, this.field.data_format))
            .text(d => $this.addChartLabel(d))
            .call(text => text.filter(d => x(d.value) - x(0) < 60) // short bars
            .attr("dx", +4)
            .attr("fill", "black")
            .attr("text-anchor", "start"))
            .on("mouseover", function(event, d) {
                    $this.mouseover(event, d);                    
                    d3.select(this)
                        .attr("class", function (d) {return 'highlight'});
                })
                
                .on("mouseout", function(d, i) {
                    $this.tooltip.transition()
                        .duration(200)
                        .style("opacity", 0);
                    d3.select(this)
                        .attr("class", function (d) {if (d.featured) {return 'featured';} return '';})

                })
            
        // $this.svg.append("g")
        //     .style("font", "bold 12px var(--sans-serif)")
        //     .style("font-variant-numeric", "tabular-nums")
        //     .attr("text-anchor", "end")
        //     .data(data)
        //     .text(d => $this.addChartLabel(d))
           
        /*    
        $this.svg.append("g")
            .call(xAxis);
        */
        /*
        $this.svg.append("g")
            .call(yAxis);                
        */
        this.setTooltip();
        
    },
    methods: {

        addChartLabel(d) {
            let result = '';
            if (d.district) {
                let name = d.district.substring(0, 4);
                result += name + '... ';
            }
            
            result += formatSlideData(d.value, this.field.data_format);
            return result;
        },
        makeid () {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < 10; i++) {
              text += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            
            return text;
        },
        setTooltip () {
            let $this = this

            this.tooltip = d3.select("#" + $this.chartid)
                .append("div")
                .attr("class", "map_tooltip")
                .attr("id", $this.tooltipid)
                .style("opacity", 0);            
        },
        mouseover (event, d) {
            let $this = this;
            if (!document.getElementById($this.tooltipid)) {$this.setTooltip();}
            let pageX = event.pageX;
            let pageY = event.pageY;

            pageX = event.clientX;
            pageY = event.clientY;
            let html = '';
            if (d.district) {
                html += d.district + " (" + d.StAbr + ") - ";
                if (d.value) {
                    html += formatSlideData(d.value, this.field.data_format, this.field)                    
                }
            }
            $this.tooltip.transition()
                .duration(200)
                .style("opacity", .95);
            $this.tooltip.html(html)                
                .style("left", (pageX + 5) + "px")
                .style("top", (pageY - 30) + "px");
        }
    }
});